import React, { useState } from 'react'
import { graphql } from "gatsby";
import Testimonial from './Testimonial';

export default function BlockifiedModel({ data }) {
  const { testimonialItems } = data.modelLink
  const [activeTestimonial, setActiveTestimonial] = useState(testimonialItems[0])

  const updateActiveTestimonial = (isNext) => {
    if (isNext) {
      const index = testimonialItems.indexOf(activeTestimonial)
      const nextTestimonial = testimonialItems[index + 1] ? testimonialItems[index + 1] : testimonialItems[0]
      setActiveTestimonial(nextTestimonial)
    } else {
      const index = testimonialItems.indexOf(activeTestimonial)
      const prevTestimonial = testimonialItems[index - 1] ? testimonialItems[index - 1] : testimonialItems[testimonialItems.length - 1]
      setActiveTestimonial(prevTestimonial)
    }
  }

  return (
    <section className="hds-container hds-text-color therm-light-bg">
      <Testimonial activeTestimonial={activeTestimonial} updateActiveTestimonial={updateActiveTestimonial} hasMultipleTestimonials={testimonialItems.length > 1}/>
    </section>
  )
}

export const blockifiedModelQuery = graphql`
  fragment BlockifiedModelComponent on DatoCmsBlockifiedModel {
    internal {
      type
    }
    modelLink {
      testimonialItems {
        id
        locale
        copy
        heading
        callToActionButtonLink
        callToActionButtonText
        featuredImage {
          gatsbyImageData
          alt
        }
        testimonialLogo {
          alt
          gatsbyImageData
        }
      }
    }
  }
`